import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Catalog = styled.div`
  background-color: #fff;
  border-bottom: 1px solid #eee;
  min-height: 100vh;
`;

export const CatalogHome = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  overflow-y: auto;
  height: 100%;
`

export const CatalogHomeCategories = styled(CatalogHome)`
  gap: 1rem;
`

export const CatalogCategorieTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.mono.greyLight};
`

export const CatalogCategorieTitle = styled.h3`
  color: ${({ theme }) => theme.colors.primary.default};
`

export const SeeMoreBtn = styled(Link)`
  color: ${({ theme }) => theme.colors.primary.dark};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSize.xs};
  text-decoration: none;
`

export const CatalogProductsSwiper = styled(Swiper)`
  .swiper-slide {
    width: 24rem;
    height: auto;
  }
`;

export const CatalogSlide = styled(SwiperSlide)`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SwiperProductsWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.mono.greyLight};
  border-radius: 8px;
  padding: 1rem;
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  position: relative;
  z-index: 10002;
`
